import dayjs from "dayjs";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  importBatch: null,

  importEvent: {
    error: {},
    progress: {},
    stage: {},
    warnings: [],
  },

  importRows: { count: 0, results: [] },
  importRowsParams: { limit: 100, offset: 0 },
};

export const ingestSlice = createSlice({
  name: "ingest",
  initialState,
  reducers: {
    mutateImportRowsParams: (state, action) => {
      state.importRowsParams = {
        ...state.importRowsParams,
        ...action.payload,
      };
    },
    resetImportBatch: state => {
      state.importBatch = initialState.importBatch;
    },
    resetImportEvent: state => {
      state.importEvent = initialState.importEvent;
    },
    resetImportRows: state => {
      state.importRows = initialState.importRows;
    },
    resetImportRowsParams: state => {
      state.importRowsParams = {
        limit: state.importRowsParams.limit,
        offset: initialState.importRowsParams.offset,
      };
    },
    setBulkProcessUpdate: (state, action) => {
      const payload = action?.payload || {};
      const importBatch = payload.import_batch;
      const importEvent = payload.import_event;

      if (!importBatch && !importEvent) return;

      if (importBatch && typeof importBatch === "object") {
        state.importBatch = { ...(state.importBatch || {}), ...importBatch };
      } else if (importEvent && typeof importEvent === "object") {
        const { type, payload: ev = {}, date_of_creation } = importEvent;

        function checkIsAfter(currentDT) {
          if (!currentDT) return true;
          return Boolean(dayjs(date_of_creation).isAfter(currentDT));
        }

        switch (type) {
          case "warning": {
            if (!Array.isArray(state.warnings)) state.warnings = [];
            state.importEvent.warnings.push({ ...ev, date_of_creation });
            break;
          }

          default:
            const currentDT = state.importEvent[type]?.date_of_creation;
            if (checkIsAfter(currentDT)) {
              state.importEvent[type] = { ...ev, date_of_creation };
            }
        }
      }
    },
    setImportBatch: (state, action) => {
      state.importBatch = action.payload;
    },
    setImportRows: (state, action) => {
      const { count, results } = action.payload;
      state.importRows = { ...state.importRows, count, results };
    },
    setImportRowsParams: (state, action) => {
      state.importRowsParams = action.payload;
    },
  },
});

export const {
  mutateImportRowsParams,
  resetImportBatch,
  resetImportEvent,
  resetImportRows,
  resetImportRowsParams,
  setBulkProcessUpdate,
  setImportBatch,
  setImportRows,
  setImportRowsParams,
} = ingestSlice.actions;

export default ingestSlice.reducer;
